import {
  CLOSE_OBSERVER,
  CLOSED_OBSERVER,
  OBSERVER_ERROR,
  RESET_OBSERVER,
} from "./actionTypes";

const initialState = {
  status: {},
};

const SpyChat = (state = initialState, action) => {
  switch (action.type) {
    case RESET_OBSERVER:
      state = initialState;
      break;
    case OBSERVER_ERROR:
      state = {
        ...state,
        status: {
          ...state.status,
          [action.payload.action]: {
            error: {
              status: true,
              message: action.payload.message,
            },
            loading: false,
            success: false,
          },
        },
      };
      break;
    case CLOSE_OBSERVER:
      state = {
        ...state,
        data: action.payload,
        status: {
          ...state.status,
          close_observer: {
            error: false,
            loading: true,
            success: false,
          },
        },
      };
      break;
    case CLOSED_OBSERVER:
      state = {
        ...state,
        status: {
          ...state.status,
          close_observer: {
            error: false,
            loading: false,
            success: true,
          },
        },
      };
      break;
    default:
      // do nothing
      break;
  }
  return state;
};

export default SpyChat;
